export const DrawerTitle = ({ title }) => (
  <div className="DrawerTitleComponent flex justify-center items-center text-center mt-16 mb-10">
    <h1 className="font-ocr text-4xl text-dashboardtext">{title}</h1>
  </div>
)
